import { useEffect, useState } from "react";

/**
 * Boolean state persisted to localStorage.
 *
 * UI-only helper: remembers an open/closed flag across reloads so the
 * user doesn't have to re-collapse filter panels or info strips every
 * time they land on a page.
 *
 * @param {string} key      localStorage key (es. "occurrences:filtersOpen")
 * @param {boolean} initial value to use when no entry exists yet
 */
export function usePersistedBoolean(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      if (stored === null) return initial;
      return stored === "1";
    } catch {
      return initial;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(key, value ? "1" : "0");
    } catch {
      /* ignore quota / private-mode errors */
    }
  }, [key, value]);
  return [value, setValue];
}
